import { HeroBanner } from "@/components/landing/hero-banner";
import { WhyChooseSection } from "@/components/landing/why-choose-section";
import { StatsSection } from "@/components/landing/stats-section";
import { ClientLogos } from "@/components/landing/client-logos";

export const LandingPage = () => {
  return (
    <>
      <HeroBanner />
      <WhyChooseSection />
      <StatsSection />
      {/* <ClientLogos /> */}
      {/* <CtaSection /> */}
    </>
  );
};
